<template>
  <el-tabs v-model="active" type="border-card">
    <el-tab-pane label="正常区盘点" :name="constantMap.normal">
      <div v-loading.body="loading">
        <el-row class="filter">
          <el-col>
            <div
              style="
                background: #f3f3f3;
                height: 30px;
                line-height: 30px;
                padding: 0 25px;
                display: flex;
                align-items: center;
              "
            >
              <div>查询搜索</div>
              <el-button
                type="text"
                style="margin-left: auto"
                :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
                @click="toggleFilter"
                >{{ filterFold ? "展开筛选" : "收起筛选" }}</el-button
              >
            </div>
            <el-collapse-transition>
              <div v-show="!filterFold">
                <div style="padding: 10px 25px">
                  <el-form
                    :inline="true"
                    :model="form"
                    class="demo-form-inline"
                  >
                    <el-form-item>
                      <el-input
                        v-model="form.inventory_no"
                        placeholder="盘点单号"
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                      <el-select
                        v-model="form.inventory_status"
                        placeholder="盘点状态"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_status"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.inventory_type"
                        placeholder="盘点类型"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_type"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.inventory_model"
                        placeholder="盘点方式"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_model"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.area_type"
                        placeholder="盘点仓区"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.area_type"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-select
                        v-model="form.inventory_times"
                        placeholder="盘点次数"
                        filterable
                        style="width: 150px"
                      >
                        <el-option label="全部" value="0"></el-option>
                        <el-option
                          v-for="item in searchOptions.inventory_times"
                          :key="item.key"
                          :label="item.label"
                          :value="item.key"
                        ></el-option>
                      </el-select>
                    </el-form-item>

                    <el-form-item label="创建时间：">
                      <el-date-picker
                        v-model="form.create_time"
                        type="datetimerange"
                        :default-time="['06:00:00', '06:00:00']"
                        v
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="开始时间：">
                      <el-date-picker
                        v-model="form.begin_time"
                        type="datetimerange"
                        :default-time="['06:00:00', '06:00:00']"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束时间：">
                      <el-date-picker
                        v-model="form.end_time"
                        type="datetimerange"
                        :default-time="['06:00:00', '06:00:00']"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                      >
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item>
                      <el-button type="primary" @click="search">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="" @click="reset">重置</el-button>
                    </el-form-item>
                    <el-form-item>
                      <el-button type="success" @click="exportExcel">
                        导出</el-button
                      >
                    </el-form-item>
                  </el-form>
                </div>
              </div>
            </el-collapse-transition>
          </el-col>
        </el-row>
        <el-row>
          <el-col style="border: 1px solid #ddd">
            <div style="margin-bottom: 0">
              <div
                style="
                  background: #f3f3f3;
                  height: 50px;
                  line-height: 30px;
                  padding: 0 25px;
                  display: flex;
                  align-items: center;
                "
              >
                &nbsp;&nbsp;&nbsp;&nbsp;数据列表
                <el-button
                  style="margin-left: auto; margin-right: -15px"
                  type="success"
                  size="mini"
                  @click="visible = true"
                  >创建盘点</el-button
                >
              </div>
              <el-table
                v-if="resData"
                ref="multipleTable"
                v-loading="tableLoading"
                height="800"
                :data="resData.list"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChange"
              >
                <el-table-column
                  align="center"
                  show-overflow-tooltip
                  prop="inventory_no"
                  label="盘点单号"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  show-overflow-tooltip
                  prop="inventory_area_type"
                  label="盘点仓区"
                  width="150"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="areas"
                  label="正常区仓区"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_type"
                  label="盘点类型"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_model"
                  label="盘点方式"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_space_type_text"
                  label="盘点仓位类型"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_times"
                  label="盘点次数"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="admin_name"
                  label="创建人"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="create_time"
                  label="创建时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="begin_time"
                  label="开始时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="end_time"
                  label="结束时间"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="inventory_inventory_status"
                  label="盘点状态"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="speed"
                  label="盘点进度"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="should_count"
                  label="应盘数量"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="actual_count"
                  label="实盘数量"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="true_percent"
                  label="库存准确率"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="totalDiffNum"
                  label="差异数量（绝对值）"
                ></el-table-column>
                <el-table-column
                  align="center"
                  prop="totalDiffPrice"
                  label="差异成本（绝对值）"
                ></el-table-column>
                <el-table-column align="center" prop="remark" label="备注说明">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      @click="setRemark(scope.row)"
                    ></el-button>
                    <span>{{ scope.row.remark }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="200">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="openDetail(scope.row.inventory_id)"
                      >明细</el-button
                    >
                    <el-button
                      type="text"
                      @click="openLog(scope.row.inventory_no)"
                    >
                      日志</el-button
                    >
                    <el-button
                      type="text"
                      @click="deleteInventory(scope.row.inventory_id)"
                    >
                      废除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div v-if="resData" style="text-align: right; padding: 25px">
              <el-pagination
                :current-page.sync="curPage"
                background
                layout="total, prev, pager, next, jumper ,sizes"
                :total="resData.count"
                :page-size="form.pagesize"
                :page-sizes="[50, 100, 200, 500, 1000]"
                @current-change="handleCurrentChange"
                @size-change="handleSizeChange"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>

        <el-dialog title="备注" :visible.sync="remarkVisible">
          <el-form :model="form">
            <el-form-item>
              <el-input v-model="remark" placeholder="备注"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="remarkVisible = false">取 消</el-button>
            <el-button type="primary" @click="doRemark">确 定</el-button>
          </div>
        </el-dialog>

        <Add v-if="visible" @onCloseDialog="closeBox"></Add>
      </div>
    </el-tab-pane>
    <el-tab-pane label="次品区盘点" :name="constantMap.defective">
      <YsDataTable
        :refresh="refreshDefective"
        :list="searchListDefective"
        :button-list="buttonListDefective"
        :fetch-method="fetchMethodDefective"
        :columns="columnsDefective"
        :dep-option-map="searchOptions"
        use-data-field
        page-size-alias="pageSize"
      >
        <template #actions="{ row }">
          <el-button
            type="primary"
            size="small"
            style="margin: 4px"
            @click="handleViewDetail(row)"
          >
            明细
          </el-button>
          <el-button
            type="info"
            size="small"
            style="margin: 4px"
            @click="handleViewLog(row)"
          >
            日志
          </el-button>
          <el-button
            type="danger"
            size="small"
            style="margin: 4px"
            :disabled="
              [constantMap.isDone, constantMap.isRepealed].includes(
                row.inventory_status
              )
            "
            @click="handleRepeal(row)"
          >
            废除
          </el-button>
        </template>
      </YsDataTable>
      <el-dialog
        :visible.sync="visibleCreate"
        title="创建盘点"
        @close="handleDialogInventoryClose"
      >
        <el-form ref="formCreate" :model="formCreate">
          <el-form-item label="盘点类型">
            <span>全盘</span>
          </el-form-item>
          <el-form-item label="盘点方式">
            <span>明盘</span>
          </el-form-item>
          <el-form-item label="盘点仓区">
            <span>次品区</span>
          </el-form-item>
          <el-form-item
            label="盘点包裹"
            prop="packageNoList"
            :rules="rules.ruleChangeArray"
          >
            <el-select
              v-model="formCreate.packageNoList"
              multiple
              filterable
              @change="handlePackageChange"
            >
              <el-option
                :label="constantMap.optionsAll"
                :value="constantMap.optionsAll"
              ></el-option>
              <el-option
                v-for="item in optionsMap.packageList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input
              v-model="formCreate.remark"
              type="textarea"
              show-word-limit
              :maxlength="constantMap.maxRemark"
            ></el-input>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="visibleCreate = false">取消</el-button>
          <el-button type="primary" @click="handleConfirmCreate">
            确定
          </el-button>
        </template>
      </el-dialog>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import dayjs from "dayjs";
import apiBaseURL from "@/utils/baseUrl.js";
import Add from "./components/CreateInventory.vue";
import * as defectiveInventoryApi from "@/controller/defectiveInventory3634.js";
import { openDownloadWindow } from "@/utils/export.js";
import rules from "@/const/rules.js";

const constantMap = Object.freeze({
  normal: "0",
  defective: "1",
  monthGap: 6,
  maxRemark: 400,
  isDone: "10", // 盘点已结束
  isRepealed: "11", // 盘点已作废
  optionsAll: "全部",
  optionsTimes: [
    { value: 0, label: "全部" },
    { value: 1, label: "初盘" },
    { value: 9, label: "终盘" },
  ],
  optionsStatus: [
    { value: 0, label: "全部" },
    { value: 1, label: "待盘点" },
    { value: 2, label: "一盘进行中" },
    { value: 3, label: "一盘已完成" },
    { value: 7, label: "待终盘" },
    { value: 8, label: "终盘进行中" },
    { value: 9, label: "终盘已完成" },
    { value: 10, label: "盘点已结束" },
    { value: 11, label: "已作废" },
  ],
});

export default {
  components: {
    Add,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchCondition();
      vm.refresh = true;
    });
  },
  data() {
    return {
      constantMap,
      rules,
      remarkVisible: false,
      visible: false,
      images: [],
      showbox: false,
      fileList: [],
      resData: {},
      form: {
        pagesize: 50,
        create_time: this.defaultDate(),
        begin_time: [],
        end_time: [],
      },
      space: "",
      ss_id: 0,
      loading: false,
      tableLoading: false,
      url: "/erp/Inventory/InventoryList",
      curPage: 1,
      filterFold: false,
      isAll: false,
      searchOptions: {},
      inventory_id: 0,
      remark: "",
      active: constantMap.normal,
      // 次品变量 以防将来好拆
      refreshDefective: false,
      fetchMethodDefective: defectiveInventoryApi.getInventoryDpList,
      searchListDefective: [
        {
          tag: "input",
          label: "盘点单号",
          field: "inventoryDpNo",
        },
        {
          tag: "select",
          label: "盘点状态",
          field: "inventoryStatus",
          options: constantMap.optionsStatus,
        },
        {
          tag: "select",
          label: "盘点次数",
          field: "inventoryTimes",
          options: constantMap.optionsTimes,
        },
        {
          tag: "date",
          label: "创建时间",
          field: "create_time",
          defaultValue: [
            dayjs()
              .subtract(constantMap.monthGap, "month")
              .format("YYYY-MM-DD 06:00:00"),
            dayjs().format("YYYY-MM-DD 06:00:00"),
          ],
          props: {
            type: "datetimerange",
            defaultTime: ["06:00:00", "06:00:00"],
            "value-format": "yyyy-MM-dd HH:mm:ss",
            format: "yyyy-MM-dd HH:mm:ss",
          },
          transform: (value = []) => {
            if (value) {
              return {
                createStartTime: value[0] ? dayjs(value[0]).unix() : "",
                createEndTime: value[1] ? dayjs(value[1]).unix() : "",
              };
            }
            return {
              createStartTime: "",
              createEndTime: "",
            };
          },
        },
        {
          tag: "date",
          label: "开始时间",
          field: "beginStartTime",
          props: {
            type: "datetimerange",
            defaultTime: ["06:00:00", "06:00:00"],
            "value-format": "yyyy-MM-dd HH:mm:ss",
            format: "yyyy-MM-dd HH:mm:ss",
          },
          transform: (value = []) => {
            if (value) {
              return {
                beginStartTime: value[0] ? dayjs(value[0]).unix() : "",
                beginEndTime: value[1] ? dayjs(value[1]).unix() : "",
              };
            }
            return {
              beginStartTime: "",
              beginEndTime: "",
            };
          },
        },
        {
          tag: "date",
          label: "结束时间",
          field: "endStartTime",
          props: {
            type: "datetimerange",
            defaultTime: ["06:00:00", "06:00:00"],
            "value-format": "yyyy-MM-dd HH:mm:ss",
            format: "yyyy-MM-dd HH:mm:ss",
          },
          transform: (value = []) => {
            if (value) {
              return {
                endStartTime: value[0] ? dayjs(value[0]).unix() : "",
                endEndTime: value[1] ? dayjs(value[1]).unix() : "",
              };
            }
            return {
              endStartTime: "",
              endEndTime: "",
            };
          },
        },
      ],
      buttonListDefective: [
        {
          tag: "button",
          text: "导出",
          props: {
            type: "success",
          },
          event: {
            handler: this.handleExportExcelList,
          },
        },
        {
          tag: "button",
          text: "创建盘点",
          props: {
            type: "primary",
          },
          event: {
            handler: this.handleInventoryCreate,
          },
        },
      ],
      columnsDefective: [
        {
          label: "盘点单号",
          prop: "inventory_dp_no",
        },
        {
          label: "盘点仓区",
          prop: "inventory_area_formal",
        },
        {
          label: "盘点包裹",
          prop: "packageListStr",
          "show-overflow-tooltip": true,
        },
        {
          label: "盘点类型",
          prop: "inventory_type_formal",
        },
        {
          label: "盘点方式",
          prop: "inventory_mode_formal",
        },
        {
          label: "盘点次数",
          prop: "inventory_times_formal",
        },
        {
          label: "创建人",
          prop: "create_admin",
        },
        {
          label: "创建时间",
          prop: "created_at",
        },
        {
          label: "开始时间",
          prop: "begin_time_formal",
        },
        {
          label: "结束时间",
          prop: "end_time_formal",
        },
        {
          label: "盘点状态",
          prop: "inventory_status_formal",
        },
        {
          label: "盘点进度",
          prop: "inventory_progress",
        },
        {
          label: "应盘数量",
          prop: "should_count",
        },
        {
          label: "实盘数量",
          prop: "inventory_num",
        },
        {
          label: "差异数量（绝对值）",
          prop: "totalDiffNum",
        },
        {
          label: "差异成本（绝对值）",
          prop: "totalDiffPrice",
        },
        {
          label: "库存准确率",
          prop: "stock_inventory_rate",
        },
        {
          label: "备注说明",
          prop: "remark",
        },
        {
          label: "操作",
          slot: "actions",
        },
      ],
      visibleCreate: false,
      formCreate: {
        packageNoList: [],
        remark: "",
      },
      optionsMap: {
        packageList: [],
      },
    };
  },
  computed: {
    filteredForm() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  methods: {
    setRemark(row) {
      this.inventory_id = row.inventory_id;
      this.remark = row.remark;
      this.remarkVisible = true;
    },
    doRemark() {
      this.$http
        .post("/erp/Inventory/updateRemark", {
          inventory_id: this.inventory_id,
          remark: this.remark,
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success(res.data.msg);
            this.remarkVisible = false;
            this.fetchData();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    openDetail(inventoryId) {
      this.$router.push(`/home/inventory/detail/${inventoryId}`);
    },
    deleteInventory(inventoryId) {
      this.$confirm(`废除盘点将导致盘点终止，盘点结果无效，是否继续作废!`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .post("/erp/Inventory/deleteInventory", {
              inventory_id: inventoryId,
            })
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success(res.data.msg);
                this.fetchData();
              } else {
                this.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {});
    },
    openLog(inventoryNo) {
      this.$router.push(
        `/home/inventory/inventorylog?inventory_no=${inventoryNo}&type=${this.active}`
      );
    },
    defaultDate() {
      return this.$excalibur.getDateTimeOnHours(-4, 6);
    },
    closeBox() {
      this.visible = false;
      this.fetchData();
    },
    exportExcel() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.form.is_excel = 0;
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchCondition() {
      this.$http
        .post("/erp/Inventory/getCondition", this.filteredForm)
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.searchOptions = res.data.data;
            this.origin = res.data.data.origin;
          }
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      if (this.search_value !== "") {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
        this.form[this.search_type] = this.search_value;
      } else {
        // eslint-disable-next-line guard-for-in,no-restricted-syntax
        for (const key in this.search_options) {
          this.form[this.search_options[key].key] = "";
        }
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const multipleSelection = [];
      const claimsDetailId = [];
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in val) {
        multipleSelection[key] = val[key].work_id;
        if (val[key].claims_detail_id) {
          claimsDetailId[key] = val[key].claims_detail_id;
        }
      }
      this.multipleSelection = multipleSelection;
      this.claims_detail_id = claimsDetailId;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleSizeChange(val) {
      this.form.pagesize = val;
      this.fetchData(true);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.fetchData(true);
    },

    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    reset() {
      this.search_value = "";
      this.form = {};
      this.form.page = 1;
      this.form.pagesize = 50;
    },
    // 次品盘点方法
    handleExportExcelList(params) {
      defectiveInventoryApi
        .getInventoryDpList({ ...params, isExcel: 1 })
        .then(openDownloadWindow)
        .catch(this.$noop);
    },
    handleInventoryCreate() {
      defectiveInventoryApi
        .getCanUseDpPackageList()
        .then((res) => {
          this.optionsMap = {
            packageList: res.packageList,
          };
          this.visibleCreate = true;
        })
        .catch(this.$noop);
    },
    handlePackageChange(value) {
      if (value.includes(constantMap.optionsAll)) {
        this.formCreate.packageNoList = this.optionsMap.packageList.slice();
      }
    },
    handleDialogInventoryClose() {
      this.$refs.formCreate.resetFields();
      this.formCreate = {
        packageNoList: [],
        remark: "",
      };
    },
    handleConfirmCreate() {
      this.$refs.formCreate.validate((valid) => {
        if (valid) {
          defectiveInventoryApi
            .createInventoryDp({
              ...this.formCreate,
              packageNoList: this.formCreate.packageNoList.join(","),
            })
            .then(() => {
              this.$message.success("创建成功！");
              this.visibleCreate = false;
              this.refreshDefective = true;
            })
            .catch(this.$noop);
        }
      });
    },
    handleViewDetail(row) {
      this.$router.push({
        path: `/home/inventory/defective-detail/${row.id}`,
      });
    },
    handleViewLog(row) {
      this.$router.push({
        path: `/home/inventory/inventorylog?inventory_dp_no=${row.inventory_dp_no}&type=${this.active}`,
      });
    },
    handleRepeal(row) {
      this.$confirm(
        "废除盘点将导致盘点终止，盘点结果无效，是否继续操作废除？",
        "",
        {}
      )
        .then(() => {
          defectiveInventoryApi
            .setInvoiceDpAbolish({ inventoryDpId: row.id })
            .then(() => {
              this.$message.success("废除成功！");
              this.refreshDefective = true;
            })
            .catch(this.$noop);
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 12px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/inventory/List.vue